<template>
  <ColumnsEffect>
    <div
      v-for="groupItem of items"
      :key="groupItem.group.uid"
      class="column is-3 is-marginless is-paddingless"
      @contextmenu.prevent="$emit('menu', { e: $event, groupItem: groupItem })"
    >
      <router-link
        v-if="!groupItem.group.edit"
        :to="
          `/domains/${$route.params.domainUID}/groups/${groupItem.group.uid}/packages`
        "
      >
        <span class="icon">
          <i class="mdi mdi-monitor-multiple"></i>
        </span>
        <span>{{ groupItem.group.name }}</span>
      </router-link>
      <EditSingleField
        v-if="groupItem.group.edit"
        :text="groupItem.group.name"
        validation="required"
        type="text"
        name="name"
        @save="$emit('save', { groupItem: groupItem, text: $event })"
        @cancel="$emit('cancel', groupItem)"
        :isLoading="groupItem.group.saving"
      ></EditSingleField>
    </div>
  </ColumnsEffect>
</template>

<script>
export default {
  props: { items: Array },
  components: {
    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),

    ColumnsEffect: () => import("@/components/singles/ColumnsEffect.vue"),
  },
};
</script>
